﻿import { TableauEventType } from "https://us-east-1.online.tableau.com/javascripts/api/tableau.embedding.3.latest.js";

let currentWidth,
    scalingFactor,
    mediaQuery,
    maxWidth,
    activeSheet,
    behaviour; //dashboard behaviour when published to Tableau Server/Cloud. "Automatic/Exactly/Range"

// Get the viz object from the HTML web component
const allViz = document.querySelectorAll('tableau-viz, tableau-authoring-viz');
const mediaQueryString = "(max-width: 576px)";

// window.token is the JWT generated using a Connected App configured with Direct Trust.
// The value is generated and is only available when this code executes within the Embedding Playground.
// See the Connected Apps documentation (https://sfdc.co/ca-direct) for more information.
// See this repository (https://sfdc.co/ca-jwt) for samples in various languages.
allViz.forEach(viz => {
    viz.token = window.token;
});

// Wait for the viz to become interactive
await new Promise((resolve, reject) => {
    // Add an event listener to verify the viz becomes interactive
    allViz.forEach(viz => {
        viz.parentElement.classList.add('db-loading');

        viz.addEventListener(TableauEventType.FirstInteractive, () => {
            resolve();
        });
        viz.addEventListener(TableauEventType.VizLoadError, (error) => {
            const message = JSON.parse(error.detail.message);
            const errorMessage = JSON.parse(message.errorMessage);
            const displayMessage = `ca-error-${errorMessage.result.errors[0].code}`;
            reject(displayMessage);
        });

        viz.addEventListener(TableauEventType.FirstInteractive, vizReady);
    });
});

export function vizReady() {
    allViz.forEach(viz => {
        var vizDiv = viz.parentElement;
        var vizDivContainer = vizDiv.parentElement;
        activeSheet = viz.workbook.activeSheet;
        behaviour = activeSheet._workbookImpl._activeSheetImpl._sheetInfoImpl._sheetSize.behavior;

        
        vizDivContainer.style.height = "unset";

        if (behaviour === "exactly") {
            maxWidth = activeSheet._workbookImpl._activeSheetImpl._sheetInfoImpl._sheetSize.maxSize.width;
        }

        // check if we need to apply the 1st scaling on load, check if it's phone or mobile
        maxWidth = viz.closest('.fullscreen').offsetWidth;
        currentWidth = 1300;
        mediaQuery = window.matchMedia(mediaQueryString);
        if (mediaQuery.matches) {
            // viz.device = "phone";
            scaleViz(viz, currentWidth, maxWidth, "phone");
        } else {
            scaleViz(viz, currentWidth, maxWidth, "desktop");
        }
    });
}

window.addEventListener("resize", () => {
    console.log("Screen size is changing; mediaQuery.matches: ", mediaQuery.matches);

    if (mediaQuery.matches) {
        // if device change (from desktop/default to phone), load 'phone' version and scale
        allViz.forEach(viz => {
            var vizDiv = viz.parentElement;
            maxWidth = vizDiv.offsetWidth;
            currentWidth = 1300;
            console.log('currentWidth: ', currentWidth);
            if (viz.device === "desktop" || viz.device === "default") {
                viz.device = "phone";
                scaleViz(viz, currentWidth, maxWidth, "phone");
                // if no device changes, then just scale
            } else {
                scaleViz(viz, currentWidth, maxWidth, "phone");
            }
        });
    } else {
        //size change from phone to desktop
        allViz.forEach(viz => {
            var vizDiv = viz.parentElement;
            maxWidth = vizDiv.offsetWidth;
            currentWidth = 1300;
            console.log('currentWidth: ', currentWidth);
            if (viz.device === "phone") {
                viz.device = "desktop";
                scaleViz(viz, currentWidth, maxWidth, "desktop");

                // if no device change, then just scale
            } else {
                scaleViz(viz, currentWidth, maxWidth, "desktop");
            }
        });
    }
});

function scaleViz(currentViz, currentWidth, maxWidth, deviceType) {
    if (behaviour === "exactly") {
        var vizParent = currentViz.parentElement;
        var vizDivContainer = vizParent.parentElement;
        vizParent.classList.remove('db-loading');
        vizParent.style.transformOrigin = "left top";
        scalingFactor = maxWidth / currentWidth;

        if (deviceType === "phone") {
            scalingFactor = 1;
        }

        console.log("Current width: ", currentWidth, "; maxWidth: ", maxWidth +
            "; scalling Factor: ", scalingFactor, "; device= ", currentViz.device);

        vizParent.style.transform = "scale(" + scalingFactor + ")";
        vizDivContainer.style.height = vizParent.offsetHeight * scalingFactor + "px";
        currentViz.style.display = "block";
        vizParent.style.visibility = "visible";
    }
}

let expandButtons = document.querySelectorAll('a.btn[href="#open"]');
expandButtons.forEach(btn => {
    btn.addEventListener('resizeTableauDash', function () {
        vizReady();
    });
})